const CommonColumns = [
    {
        field: 'Company',
        title: 'Company'
    },
    {
        field: 'Id',
        title: 'Id'
    },
    {
        field: 'IsAssigned',
        title: 'IsAssigned'
    },
    {
        field: 'IsAvailable',
        title: 'IsAvailable'
    },
    {
        field: 'IsDecommissioned',
        title: 'IsDecommissioned'
    },
    {
        field: 'IsLostOrStolen',
        title: 'IsLostOrStolen'
    },
    {
        field: 'IsReleased',
        title: 'IsReleased'
    },
    {
        field: 'Location',
        title: 'Location'
    },
    {
        field: 'Name',
        title: 'Name'
    },
    {
        field: 'Status',
        title: 'Status'
    },
    {
        field: 'Type',
        title: 'Type'
    },
    {
        field: 'UserName',
        title: 'UserName'
    }
]
const KaceColumns = [

    {
        field: 'CreatedDate',
        title: 'CreatedDate'
    },
    {
        field: 'ImageName',
        title: 'ImageName'
    },
    {
        field: 'IpAddress',
        title: 'IpAddress'
    },
    {
        field: 'KaceGuid',
        title: 'KaceGuid'
    },
    {
        field: 'KaceId',
        title: 'KaceId'
    },
    {
        field: 'LastInventory',
        title: 'LastInventory'
    },
    {
        field: 'LastShutdown',
        title: 'LastShutdown'
    },
    {
        field: 'LastSync',
        title: 'LastSync'
    },
    {
        field: 'LastUser',
        title: 'LastUser'
    },
    {
        field: 'LastUserId',
        title: 'LastUserId'
    },
    {
        field: 'MacAddress',
        title: 'MacAddress'
    },
    {
        field: 'MachineName',
        title: 'MachineName'
    },
    {
        field: 'Manufacturer',
        title: 'Manufacturer'
    },
    {
        field: 'Model',
        title: 'Model'
    },
    {
        field: 'ModifiedDate',
        title: 'ModifiedDate'
    },
    {
        field: 'Uptime',
        title: 'Uptime'
    },
    {
        field: 'UserEmpNum',
        title: 'UserEmpNum'
    },
    {
        field: 'UserFullName',
        title: 'UserFullName'
    },
    {
        field: 'UserId',
        title: 'UserId'
    },
    {
        field: 'UserLogged',
        title: 'UserLogged'
    },
];
const WirelessWatchdogsColumns = [
    {
        field: 'Account',
        title: 'Account'
    },
    {
        field: 'ActivationDate',
        title: 'ActivationDate'
    },
    {
        field: 'ContractExpirationDate',
        title: 'ContractExpirationDate'
    },
    {
        field: 'CostCenters',
        title: 'CostCenters'
    },
    {
        field: 'EmpNum',
        title: 'EmpNum'
    },
    {
        field: 'ImageName',
        title: 'ImageName'
    },
    {
        field: 'Imei',
        title: 'Imei'
    },
    {
        field: 'InternationalEnabled',
        title: 'InternationalEnabled'
    },
    {
        field: 'MobileHotspotEnabled',
        title: 'MobileHotspotEnabled'
    },
    {
        field: 'MobileStatus',
        title: 'MobileStatus'
    },
    {
        field: 'MobileType',
        title: 'MobileType'
    },
    {
        field: 'Model',
        title: 'Model'
    },
    {
        field: 'PhoneNumber',
        title: 'PhoneNumber'
    },
    {
        field: 'Sim',
        title: 'Sim'
    },
    {
        field: 'UpgradeEligibilityDate',
        title: 'UpgradeEligibilityDate'
    },
    {
        field: 'UserEmpNum',
        title: 'UserEmpNum'
    },
];

let k_exportGrid;

export default function () {
    k_exportGrid = createGrid();
    return k_exportGrid;
}

const createGrid = () => {
    if (k_exportGrid) destroyExportGrid();
    const now = new Date();
    return $('.js-tech-asset-export-grid').kendoGrid({
        columns: CommonColumns.concat(KaceColumns).concat(WirelessWatchdogsColumns),
        dataSource: {
            data: getData()
        },
        excel: {
            fileName: `Limbach_Devices_${now.getFullYear()}${now.getMonth() + 1}${now.getDate()}.xlsx`,
            filterable: true
        }
    }).data('kendoGrid');
}

const getData = () => {
    let deviceList = [];
    const filterView = $('.js-tech-asset-grid').data('kendoGrid').dataSource.view();
    filterView.forEach(dataItem => {
        dataItem.Devices.forEach(device => {
            deviceList.push(device);
        })
    })

    return deviceList;
}

const destroyExportGrid = () => {
    k_exportGrid.destroy();
}